/* eslint-disable @typescript-eslint/no-explicit-any */

import { IGetRelatedLinks } from './interfaces.js';

export class RelatedLinkService implements IGetRelatedLinks {
  constructor(private endpoint: string) {}

  async getRelatedLinks(
    currentpage: string,
    relateby: string,
    limit: number,
    domain: string,
    language: string,
  ): Promise<Array<any>> {
    let results = [];

    try {
      const url = new URL(this.endpoint);
      url.searchParams.set('currentpage', currentpage);
      url.searchParams.set('relateby', relateby);
      url.searchParams.set('domain', domain);
      url.searchParams.set('limit', `${limit}`);
      url.searchParams.set('language', language);

      const response = await fetch(url.toString());
      results = await response.json();
    } catch (error) {
      throw new Error('Error loading related links.');
    }

    return results;
  }
}
